module.exports = __webpack_public_path__ + "img/education_ministry.cc3d01fe.png";